import { AscType, ResolutionType, SortType } from 'commons/constants/type';
import KeyFlowParamVO from 'commons/vo/param/KeyFlowParamVO';

export type LibraryParamVOProps = {
  retr?: number;
  page?: number;
  asc?: AscType;
  sort?: SortType;

  contents?: string;
  categoryId?: number;
  videoId?: number;
  resolution?: ResolutionType;
  inPoint?: number;
  outPoint?: number;
};

export type LibraryAWSParamVOProps = {
  startTimecode?: string;
  endTimecode?: string;
  videoFilePath?: string;
  assetTitle?: string;
  duration?: number;
  isClean?: boolean;
};

export type LibraryParamProps = LibraryParamVOProps & LibraryAWSParamVOProps;

class LibraryParamVO extends KeyFlowParamVO {
  retr?: number;
  page?: number;
  asc?: AscType;
  sort?: SortType;

  contents?: string;
  categoryId?: number;
  videoId?: number;
  resolution?: ResolutionType;
  inPoint?: number;
  outPoint?: number;

  startTimecode?: string;
  endTimecode?: string;
  videoFilePath?: string;
  assetTitle?: string;
  duration?: number;
  // CONTENTS?: string;
  // CATEGORY_ID?: number;
  // VIDEO_ID?: number;
  // RESOLUTION?: ResolutionType;
  // IN_POINT?: number;
  // OUT_POINT?: number;

  isClean?: boolean;

  constructor(data: LibraryParamProps) {
    super();
    this.retr = data.retr;
    this.page = data.page;
    this.sort = data.sort;
    this.asc = data.asc;

    this.contents = data.contents;
    this.categoryId = data.categoryId;
    this.videoId = data.videoId;
    this.resolution = data.resolution;
    this.inPoint = data.inPoint;
    this.outPoint = data.outPoint;

    this.startTimecode = data.startTimecode;
    this.endTimecode = data.endTimecode;
    this.videoFilePath = data.videoFilePath;
    this.assetTitle = data.assetTitle;
    this.duration = data.duration;
    // this.CONTENTS = data.contents;
    // this.CATEGORY_ID = data.categoryId;
    // this.VIDEO_ID = data.videoId;
    // this.RESOLUTION = data.resolution;
    // this.IN_POINT = data.inPoint;
    // this.OUT_POINT = data.outPoint;

    this.isClean = data.isClean;
  }
}

export default LibraryParamVO;
